module.exports = __webpack_public_path__ + "static/media/selfie.6fcfaabc.jpg";